/**
 * Legacy TerminalsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.terminalsApi`) keep resolving.
 *
 * The actual TerminalsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/terminals/terminals-api.service.ts
 */
angular.module("acme.common.service.terminalsApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
